import useIsMobile from '@/hooks/useIsMobile';
import useRegister from './useRegister';
import RegisterDesktop from './desktop';
import RegisterMobile from './mobile';

function Register() {
  const isMobile = useIsMobile(992);
  const viewModel = useRegister();

  return isMobile ? <RegisterMobile viewModel={viewModel} /> : <RegisterDesktop viewModel={viewModel} />;
}

export default Register;
